<div class="mat-elevation-z8 ccorbit-mat-table" [cdkContextMenuTriggerFor]="context_menu">
  <cdk-virtual-scroll-viewport [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34" *ngIf="modelo"
    #viewportValLat id="viewportValLat" class="wrapper2 mat-elevation-z2">
    <table cdk-table [dataSource]="ValLat" class="table-striped tableStyle tableStyle">

      <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsLat; sticky: true" class="sticky-header"></tr>
      <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsLat;" (click)="selectRow(row)"
        [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
      <ng-container *ngFor="let tablecol of tableColumnsLat">

        <ng-container [cdkColumnDef]="tablecol.id">
          <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header tableStyle">
            {{tablecol.name}}
          </th>
          <td cdk-cell *cdkCellDef="let item" [ngClass]="{
                                          'salida': item[tablecol.id] === 'SALIDA',
                                          'entrada': item[tablecol.id] === 'ENTRADA',
                                          'numero-positivo': item[tablecol.id] > 0,
                                          'numero-negativo': item[tablecol.id] < 0
                                          }"
                [style.textAlign]="item[tablecol.id] === 'TOTAL' ? 'left' : null"
                [style.paddingLeft.px]="item[tablecol.id] === 'TOTAL' ? 10 : null">
            <ng-container *ngIf="tablecol.isString">
              {{item[tablecol.id]}} <ng-container *ngIf="tablecol.id === 'compania'">
                {{item['secType'] === 'CFD' ? ' CFD' : ''}}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="tablecol.isDate">
              {{item[tablecol.id] | smartDate}}
            </ng-container>
            <ng-container *ngIf="tablecol.isNumber">
              {{item[tablecol.id] | number:(item['secType'] === 'CFD' && (tablecol.id === 'precioentrada' || tablecol.id === 'preciocierre') ? '1.5-5' : '1.2-2')}}
            </ng-container>
          </td>
        </ng-container>
      </ng-container>
    </table>
  </cdk-virtual-scroll-viewport>

  <cdk-virtual-scroll-viewport [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34" *ngIf="isPlanificador"
    #viewportValLatDiv id="viewportValLatDiv" class="wrapper2 mat-elevation-z2 tableStyle">
    <table cdk-table [dataSource]="DivValLat" class="table-striped tableStyle ">

      <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsLat; sticky: true" class="sticky-header"></tr>
      <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsLat;" (click)="selectRow(row)"
        [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
      <ng-container *ngFor="let tablecol of tableColumnsLat">

        <ng-container [cdkColumnDef]="tablecol.id">
          <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
            {{tablecol.name}}
          </th>
          <td cdk-cell *cdkCellDef="let item" [ngClass]="{
                                          'salida': item[tablecol.id] === 'SALIDA',
                                          'entrada': item[tablecol.id] === 'ENTRADA',
                                          'numero-positivo': item[tablecol.id] > 0,
                                          'numero-negativo': item[tablecol.id] < 0
                                          }">
            <ng-container *ngIf="tablecol.isString">
              {{item[tablecol.id]}} <ng-container *ngIf="tablecol.id === 'compania'">
                {{item['secType'] === 'CFD' ? ' CFD' : ''}}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="tablecol.isDate">
              {{item[tablecol.id] | smartDate}}
            </ng-container>
            <ng-container *ngIf="tablecol.isNumber">
              {{item[tablecol.id] | number:(item['secType'] === 'CFD' && (tablecol.id === 'precioentrada' || tablecol.id === 'preciocierre') ? '1.5-5' : '1.2-2')}}
            </ng-container>
          </td>
        </ng-container>
      </ng-container>
    </table>
  </cdk-virtual-scroll-viewport>

  <!-- ----------------------- GESTOR --------------------- -->
  <cdk-virtual-scroll-viewport [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34" *ngIf="isGestion"
    #viewportValLatGest id="viewportValLatGest" class="wrapper2 mat-elevation-z2 tableStyle">
    <table cdk-table [dataSource]="gestValLat" class="table-striped tableStyle">

      <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsLat; sticky: true" class="sticky-header "></tr>
      <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsLat;" (click)="selectRow(row)"
        [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
      <ng-container *ngFor="let tablecol of tableColumnsLat">

        <ng-container [cdkColumnDef]="tablecol.id">
          <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header tableStyle">
            {{tablecol.name}}
          </th>
          <td cdk-cell *cdkCellDef="let item" [ngClass]="{
                                          'salida': item[tablecol.id] === 'SALIDA',
                                          'entrada': item[tablecol.id] === 'ENTRADA',
                                          'numero-positivo': item[tablecol.id] > 0,
                                          'numero-negativo': item[tablecol.id] < 0
                                          }">
            <ng-container *ngIf="tablecol.isString">
              {{item[tablecol.id]}} <ng-container *ngIf="tablecol.id === 'compania'">
                {{item['secType'] === 'CFD' ? ' CFD' : ''}}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="tablecol.isDate">
              {{item[tablecol.id] | smartDate}}
            </ng-container>
            <ng-container *ngIf="tablecol.isNumber">
              {{item[tablecol.id] | number:(item['secType'] === 'CFD' && (tablecol.id === 'precioentrada' || tablecol.id === 'preciocierre') ? '1.5-5' : '1.2-2')}}
            </ng-container>
          </td>
        </ng-container>
      </ng-container>
    </table>
  </cdk-virtual-scroll-viewport>
  <!-- ----------------------- BROKER --------------------- -->
  <cdk-virtual-scroll-viewport [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34" *ngIf="isBroker"
    #viewportValLatBrok id="viewportValLatBrok" class="wrapperBroker mat-elevation-z2 tableStyle">
    <table cdk-table [dataSource]="brokValLat" class="table-striped tableStyle">

      <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsLat; sticky: true" class="sticky-header"></tr>
      <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsLat;" (click)="selectRow(row)"
        [ngClass]="{'selected': row === filaSeleccionada}" (contextmenu)="mostrarMenu($event, row)"></tr>
      <ng-container *ngFor="let tablecol of tableColumnsLat">

        <ng-container [cdkColumnDef]="tablecol.id">
          <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header">
            {{tablecol.name}}
          </th>
          <td cdk-cell *cdkCellDef="let item" [ngClass]="{
                                          'salida': item[tablecol.id] === 'SALIDA',
                                          'entrada': item[tablecol.id] === 'ENTRADA',
                                          'numero-positivo': item[tablecol.id] > 0,
                                          'numero-negativo': item[tablecol.id] < 0
                                          }">
            <ng-container *ngIf="tablecol.isString">
              {{item[tablecol.id]}} <ng-container *ngIf="tablecol.id === 'compania'">
                {{item['secType'] === 'CFD' ? ' CFD' : ''}}
              </ng-container>
            </ng-container>
            <ng-container *ngIf="tablecol.isDate">
              {{item[tablecol.id] | smartDate}}
            </ng-container>
            <ng-container *ngIf="tablecol.isNumber">
              {{item[tablecol.id] | number:(item['secType'] === 'CFD' && (tablecol.id === 'precioentrada' || tablecol.id === 'preciocierre') ? '1.5-5' : '1.2-2')}}
            </ng-container>
          </td>
        </ng-container>
      </ng-container>
    </table>
  </cdk-virtual-scroll-viewport>
</div>
<ng-template #context_menu let-data="data">
  <div class="example-menu" cdkMenu [ngClass]="{'dark-theme': isDark, 'light-theme': !isDark}">
    <button class="example-menu-item" (click)="verGrafica()" cdkMenuItem>
      <mat-icon class="menu-icon">insert_chart</mat-icon>
      <span>Ver Gráfica</span>
    </button>
    <button class="example-menu-item" (click)="verModelo()" cdkMenuItem>
      <mat-icon class="menu-icon">open_in_new</mat-icon>
      <span>Ver Modelo</span>
    </button>
    <button class="example-menu-item" cdkMenuItem>
      <mat-icon class="menu-icon">exit_to_app</mat-icon>
      <span>Operaciones de Salida</span>
    </button>
  </div>
</ng-template>